<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            {{ valueLabel }}
            <span v-if="periodLabel" class="period-label">
                {{ t('segments-filters-period_label', { period: periodLabel }) }}
            </span>

        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <div class="fields">
                <div class="field">
                    <label>{{ t('reportFilters-min') }}:</label>
                    <input type="tel" v-model="min" v-mask="options.mask" />
                </div>
                <div class="field">
                    <label>{{ t('reportFilters-max') }}:</label>
                    <input type="tel" v-model="max" v-mask="options.mask" />
                </div>

                <div >
                    <label >{{ t('segments-filters-which_status_to_execute') }} </label>
                    <div class="p-3">
                        <select v-model="filterStatus" class="form-control " multiple>
                        <option
                            v-for="status in statusList"
                            :value="status.id"
                            :key="status.id"
                        >
                            {{ status.external_label }}
                        </option>
                    </select>
                    </div>
                </div>

                <div
                    v-for="field in fields"
                    class="field quotation-field"
                    :key="field.id"
                >
                    <label>{{ field.field_name }}</label>
                    <select
                        v-if="field.type === 'user'"
                        class="form-control"
                        v-model="fieldValues[field.id]"
                    >
                        <option value="">{{ t('custom_fields-select_user') }}</option>
                        <option
                            v-for="option in field.options"
                            :value="option.value"
                            :key="option.value"
                        >
                            {{ option.label }}
                        </option>
                    </select>
                    <input
                        v-else
                        class="form-control"
                        v-model="fieldValues[field.id]"
                        ref="phoneField"
                    />
                </div>

                <div class="field">
                    <label class="checkbox"
                        ><input
                            type="checkbox"
                            v-model="restrictPeriod"
                        />{{ t('segments-filters-limit_time_range') }}</label
                    >
                </div>

                <template v-if="restrictPeriod">
                    <div class="field">
                        <div class="period-title">{{ t('segments-filters-days_ago') }}</div>
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-min') }}:</label>
                        <input type="tel" v-model="period.min" />
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-max') }}:</label>
                        <input type="tel" v-model="period.max" />
                    </div>
                </template>

            </div>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('segments-filters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;
    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }

    &.quotation-field {
        padding: 10px;
        flex-direction: column;
        label {
            margin: 0 0 0px;
            padding-left: 0;
        }
        input {
            margin-top: 5px;
        }
    }
}

.period-label {
    display: block;
    font-size: 9px;
}
.filter-actions {
    margin-top: 20px;
}

label.checkbox {
    font-size: 10px;

    input {
        margin-right: 5px;
    }
}

.period-title {
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0 0 10px;
}

input:not([type="checkbox"]) {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    flex-grow: 1;
    width: 100%;
    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
</style>
<script>
import keviApi from "../../keviApi";

export default {
    name: "min-max",
    props: {
        currentValue: {
            type: Object,
            default: () => ({}),
        },
        options: {
            type: Object,
            default: () => ({
                mask: "R$ ######,##",
                optionsWidth: 300,
            }),
        },
        name: {
            type: String,
            default: "min-max",
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: "",
            changedValue: false,
            min: null,
            max: null,
            period: {
                min: null,
                max: null,
            },
            restrictPeriod: false,
            fieldValues: {},
            fields: [],
            statusList: [],
            filterStatus: [ ]
        };
    },
    async mounted() {
        await this.loadFields();
        await this.loadStatusList();
        if (this.currentValue && Object.keys(this.currentValue).length > 0) {
            let value = this.currentValue;
            this.max = value.max;
            this.min = value.min;
            this.restrictPeriod = value.restrictPeriod;
            this.period.min = value.period.min;
            this.period.max = value.period.max;

            if (value.fieldValues) {
                this.fieldValues = JSON.parse(
                    JSON.stringify(value.fieldValues),
                );
            }
            if (value.filterStatus) {
                this.filterStatus = JSON.parse(
                    JSON.stringify(value.filterStatus),
                );
            }

        }
        if (this.value.length > 0) {
            this.changed();
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadFields() {
            let options = keviApi.getOptions("/quotation-fields", "GET", {
                "with-options": 1,
            });
            this.$http(options).then((response) => {
                this.fields = JSON.parse(JSON.stringify(response.body));
            });
        },
        cancel() {
            this.showOptions = false;
        },
        changed() {
            this.$emit("changed", this.value);
        },
        loadStatusList() {
            let options = keviApi.getOptions(
                "settings/external-quotations-status",
                "GET",
            );
            this.$http(options).then((response) => {
                this.loading = false;
                if (response.status === 200) {
                    this.statusList = response.body.status || [];
                }
            });
        },
        checkValuesQuotation() {
            if (this.max && this.maxFloat < this.minFloat) {
                let max = this.max;
                let min = this.min;
                this.max = min;
                this.min = max;
            }

            if (
                this.period.max &&
                this.getFloat(this.period.max) < this.getFloat(this.period.min)
            ) {
                let periodMax = this.period.max;
                let periodMin = this.period.min;
                this.period.max = periodMin;
                this.period.min = periodMax;
            }


        },
        setValue() {
            this.checkValuesQuotation();
            this.value = {
                min: this.minFloat,
                max: this.maxFloat,
                restrictPeriod: this.restrictPeriod ? 1 : "",
                period: {
                    min: this.getFloat(this.period.min),
                    max: this.getFloat(this.period.max),
                },

                fieldValues: JSON.parse(JSON.stringify(this.fieldValues)),
                filterStatus: JSON.parse(JSON.stringify(this.filterStatus)),
            };
        },
        getFloat(n) {
            if (n === null) {
                return null;
            }
            return parseFloat(
                String(n)
                    .replace(/[^0-9,]/gi, "")
                    .replace(",", "."),
            );
        },
    },
    computed: {
        maxFloat() {
            return this.getFloat(this.max);
        },
        minFloat() {
            return this.getFloat(this.min);
        },
        valueLabel() {
            const isEmpty = (v) => v === null || v === "" || v === undefined;
            if (isEmpty(this.min) && isEmpty(this.max)) {
                return this.t('segments-filters-inform_values');
            } else if (isEmpty(this.min) && !isEmpty(this.max)) {
                return this.t('segments-filters-until') + " " + this.max;
            } else if (!isEmpty(this.min) && isEmpty(this.max)) {
                return this.t('segments-filters-from') + " " + this.min;
            } else {
                return this.t('segments-filters-between') + " " + this.min + " " + this.t('segments-filters-and') + " " + this.max;
            }
        },
        periodLabel() {
            if (!this.restrictPeriod) {
                return "";
            }
            if (!this.period.min && !this.period.max) {
                return "";
            } else if (!this.period.min && this.period.max) {
                return this.t('segments-filters-until') + " " + this.period.max;
            } else if (!this.period.max && this.period.min) {
                return this.t('segments-filters-more_than') + " " + this.period.min;
            } else {
                return this.t('segments-filters-between') + " " + this.period.min + " " + this.t('segments-filters-and') + " " + this.period.max;
            }
        },

    },
    watch: {
        showOptions() {
            this.setValue();
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
